// extracted by css-extract-rspack-plugin
export default {"content":"content-MyUYz8","header":"header-Drrx15","body":"body-V_5Pvq","anchor":"anchor-J7a66r","locationIcon":"locationIcon-imP8mw","name":"name-nlq_eY","muted":"muted-FlcmWT"};